<svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
  <path d="M2 14.5H15" stroke="#E5E5E5" stroke-width="1.4" stroke-linecap="round"/>
  <path d="M3 14L13 4" stroke="#E5E5E5" stroke-width="1.4" stroke-linecap="round"/>
  <path d="M4 14.5L5.5 11" stroke="#E5E5E5" stroke-width="2.2" stroke-linecap="round"/>
  <path d="M9 8L11.5 5.5" stroke="#E5E5E5" stroke-width="2.5" stroke-linecap="round"/>
  <path d="M12 4.5L14 6.5" stroke="#E5E5E5" stroke-width="1.5" stroke-linecap="round"/>
</svg>
